<div class="container-fluid p-0">
    <form [formGroup]="settingsForm">
        <mat-card class="card mb-3  profile-common-card-container ">
            <div class="row mt-3 d-flex justify-content-between">
                <div class="col-xs-12 col-md-8 col-lg-5 col-xl-5">
                    <div class="form-group">
                        <label>{{'Preferredlanguage'|translate}}</label>
                        <p class="normal-text">{{'PreferredDesc'|translate}}</p>
                    </div>
                </div>
                <div class="col-xs-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="form-group mt-1">
                        <mat-select [disabled]='!canEdit' class="select-container w-160" formControlName="preferredLanguage" (selectionChange)="updateLanguage($event)"
                            placeholder="Select language">
                            <mat-option *ngFor="let option of optionsLang" [value]="option.name">
                                {{ translate.instant(option.name) }}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>
            </div>
            <div class="py-3">
                <mat-divider></mat-divider>
            </div>

            <div class="row d-flex justify-content-between mt-2" *ngIf="enableSetting">
                <div class="col-xs-12 col-md-6 col-lg-5 col-xl-5">
                    <div class="form-group">
                        <label>{{'Defaultapplication'|translate}}</label>
                        <p class="normal-text">{{'DefaultappDesc'|translate}}
                        </p>
                    </div>
                </div>
                <div class="col-xs-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="form-group">
                        <mat-select [disabled]='!canEdit' class="select-container w-160" formControlName="defaultAppId" (selectionChange)="updateSetting($event)"
                            placeholder="{{'Select' | translate}}">
                            <mat-option *ngFor="let option of optionsApp" [value]="option.appId">
                                {{ translate.instant(option.appName) }}
                            </mat-option>
                        </mat-select>

                    </div>
                </div>
            </div>
            <div class="py-3" *ngIf="enableSetting">
                <mat-divider></mat-divider>
            </div>
            <div class="row mt-3" *ngIf="isPromotional">
                <div class="col-xs-12 col-md-8 col-lg-8 col-xl-8">
                    <!-- <div class="form-group"> -->
                    <label>{{'Promotionalmessage'|translate}}</label>
                    <p class="normal-text">{{'PromotionDesc'|translate}}</p>
                    <!-- </div> -->
                </div>
                <div class="col-xs-12 col-md-4 col-lg-4 col-xl-4">
                    <mat-slide-toggle formControlName="isPromotionalMessage" [checked]="passAppList?.isPromotionalMessage" (change)="updateConsent(1,$event)"
                        disabled>
                        {{passAppList?.isPromotionalMessage == true ? translate.instant('On'):translate.instant('Off')}}</mat-slide-toggle>
                </div>
            </div>
            <div class="py-3" *ngIf="isPromotional">
                <mat-divider></mat-divider>
            </div>
        </mat-card>
    </form>
</div>